const SAVE_SUMMARY_TEMPLATE = 'SAVE_SUMMARY_TEMPLATE';

export default {
    SAVE_SUMMARY_TEMPLATE
};
